<template>
<div>
  <div class="row">
    <div v-if="loading" id="loader"></div>
    <div v-else class="col-12 mt-0">
      <b-card no-body  class="mb-0" style="width: 470px !important;">
        <b-card-header header-tag="header" class="p-1" role="tab">                              
          <p class="button1">1. Información del derecho de petición</p>                                
        </b-card-header>
        <b-card-body>
          <form 
            @submit="saveInfoRP"
            onsubmit="return false"
          >
            <div class="form-group row">
              <label for="inputCla" class="col-sm-4 col-form-label p1 text-right mt-2">
                <b>Categoría</b></label>
              <div class="col-sm-5 mt-3">
                <b-form-select 
                  v-model="categoria"  
                  :options="opcionCategoria" 
                  size="lg" 
                  class="mt-0"
                  @change="subcategorias"
                  :disabled="canEdit ? '' : disabled"
                  >
                </b-form-select>
              </div>
              <label for="inputCla" class="col-sm-4 col-form-label p1 text-right mt-2">
                <b>Subcategoría*</b></label>
              <div class="col-sm-5 mt-3">
                <b-form-select 
                  v-model="subcategoria"  
                  :options="opcionSubcategoria" 
                  size="lg" 
                  class="mt-0"
                  required
                  :disabled="canEdit ? '' : disabled"
                  >
                </b-form-select>
              </div>
              <label class="col-sm-3 col-form-label text-left mt-2">                
                <button 
                  v-on:click="recategorizar()"
                  type="button" 
                  class="btn btn-link"
                  :disabled="canEdit ? '' : disabled">
                  ReCategorizar
                </button>
              </label>
              <label for="inputCla" class="col-sm-4 col-form-label p1 text-right mt-2">
                <b>Business Partner</b></label>
              <div class="col-sm-5 mt-3">
                <select 
                  v-model="bp"
                  required
                  class="custom-select mb-3"
                  :disabled="canEdit ? '' : disabled"
                  >
                  <option value="">--Seleccione Business Partner--</option>
                  <option v-for="bp in bps.data" v-bind:key="bp.id" 
                    v-bind:value="bp.id">
                    {{ bp.name }}
                  </option>
                </select>
              </div>

              <label for="inputDate" class="col-sm-4 col-form-label p1 text-right mt-0">
                <b>Fecha recepción*</b></label>
              <div class="col-sm-8 mt-1">
                <b-form-datepicker
                  v-model="fecha" 
                  class="mb-2"
                  :date-format-options="{ year: 'numeric' , month: 'numeric', day: 'numeric' }"
                  placeholder="AAAA-DD-MM"
                  required
                  :readonly="canEdit ? '' : disabled"
                  >
                </b-form-datepicker>
              </div>
              <label for="inputName" class="col-sm-4 col-form-label p1 text-right mt-0">
                <b>Nombre solicitante*</b></label>
              <div class="col-sm-8 mt-1">
                <input type="text" 
                  v-model="nombreSol"
                  required class="form-control" id="inputName" 
                  placeholder="Escribe el nombre del solicitante"
                  :disabled="canEdit ? '' : disabled">
              </div>
              <label for="inputPassword" class="col-sm-4 col-form-label p1 text-right mt-2">
                <b>ID solicitante*</b></label>
              <div class="col-sm-8 mt-3">
                <input type="number" 
                  v-model="idSol"
                  required class="form-control" id="inputPassword" 
                  placeholder="Escribe el nit o cédula del solicitante"
                  :disabled="canEdit ? '' : disabled">
              </div>
              <label for="inputBene" class="col-sm-4 col-form-label p1 text-right mt-1">
                <b>Beneficiario de la petición*</b></label>
              <div class="col-sm-8 mt-3">
                <input type="text" 
                  v-model="Bene"
                  class="form-control" id="inputBene" 
                  placeholder="Escribe el nombre del beneficiario"
                  :disabled="canEdit ? '' : disabled"
                  required>
              </div>
              <label for="inputIdBene" class="col-sm-4 col-form-label p1 text-right mt-1">
                <b>ID Beneficiario*</b></label>
              <div class="col-sm-8 mt-3">
                <input type="number" 
                  v-model="idBene"
                  class="form-control" id="inputIdBene" 
                  placeholder="Escribe el NIT o cedula del beneficiario"
                  :disabled="canEdit ? '' : disabled"
                  required>
              </div>              
              <label for="inputRes" class="col-sm-4 col-form-label p1 text-right mt-2"><b>Asignado</b></label>
              <div class="col-sm-8 mt-3">
                <b-form-select 
                  v-model="subresponsable"  
                  :options="opcionSubresponsable" 
                  required
                  size="lg" 
                  class="mt-0"
                  :disabled="canEdit ? '' : disabled"
                  >
                </b-form-select>
              </div>
              <label for="inputDes" class="col-sm-4 col-form-label p1 text-right mt-2">
                <b>Descripcion*</b></label>
              <div class="col-sm-8 mt-3">
                <textarea 
                  v-model="descripcion"  
                  class="form-control" 
                  id="inputDes" rows="3" required
                  :disabled="canEdit ? '' : disabled"></textarea>
              </div>
              <div class="col-sm-12 mt-4 mb-0 text-center" v-if="this.infoRPl.status == 'open'">
                <p v-if="recategorizarValue">Si cambias la categoria, recuerda darle click a <b>Recategorizar</b></p>
                <button 
                  type="submit" 
                  class="btn btn-outline-light"
                  :disabled="canEdit || recategorizarValue ? '' : disabled">
                  <p class="p1" style="text-decoration: underline;">Guardar</p>
                </button>
              </div>
            </div>
          </form>
        </b-card-body>
      </b-card>
    </div>
  </div>
  <div>
    <b-modal 
      ref="my-modal" 
      hide-footer
      centered
      title="Atención al mensaje:"
      no-close-on-backdrop
      @hidden="hideModal">
      <div class="d-block text-center">
        <h3>{{this.msjModal}}</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger"
        block 
        @click="hideModal">
          Cerrar
      </b-button>
    </b-modal>
  </div>
</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import serverConfig from "./../../services/config";

export default {
  name: "Reception",
  components: {    
  },
  props: {
    flagComponent: {
      type: Number,      
    },
  },
  data() {
    return {
      recategorizarValue:false,
      serverPath: serverConfig.permisosURL,      
      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      addUserForm: 0,
      fecha: false,
      nombreSol: '',
      idSol: '',
      Bene: '',
      idBene: '',
      descripcion: '',
      bp: '',
      //infoRPl: [],
      responsable: '',
      opcionResponsable: [],
      categoria: '',
      opcionCategoria: [],
      subcategoria: '',
      opcionSubcategoria: [],
      subresponsable: '',
      opcionSubresponsable: [],
      disabled: false,

      msjModal: "",
      flagPath: false,
      
      canEdit: '',
    };
  },
  beforeMount() {
    let x = true
    this.actGetBP(x);
    this.canEdit = '';
    this.actGetInfoRP(this.$route.params.id).then(() =>{
      this.setInfoRPl(this.infoRP.data);
      this.actGetCategories().then(() =>{
        this.categories.data.forEach(r => {
          this.opcionCategoria.push({
            'value': r.id,
            'text': r.name
          });
          r.pr_subcategories.forEach(s => {
            
            if(s.pr_category_id == this.infoRPl.subcategory_id){
              this.opcionSubcategoria.push({
                'value': s.id,
                'text': s.name
              });
              this.categoria = r.id;
              this.subcategoria = this.infoRPl.subcategory_id;
            }
          });
        });
        let categoriaTMP = this.opcionCategoria.find(c => c.value === this.infoRPl.category_id);
        this.categoria = categoriaTMP.value;
        this.subcategorias();

        let subcategoriaTemp = this.opcionSubcategoria.find(c => c.value === this.infoRPl.subcategory_id);
        this.subcategoria = (subcategoriaTemp == undefined)? null : subcategoriaTemp.value;
      });
    });

    this.pushSubresponsables()
    
    // this.actGetResponsibles().then(() =>{
    //   this.responsibles.data.forEach(r => {
    //     this.opcionSubresponsable.push({
    //       'value': r.id,
    //       'text': r.name
    //     });
    //   });
    //   let subresponsableTemp = this.opcionSubresponsable.find(c => c.value === this.infoRPl.subresponsible_id);
    //   this.subresponsable = (subresponsableTemp != undefined)?subresponsableTemp.value: null;
    // });

    if(this.infoRPl.status != 'open'){
      this.fecha = this.infoRPl.reception_date;
      this.bp = this.infoRPl.business_partner_id;
      this.nombreSol = this.infoRPl.petitioner_name;
      this.idSol = this.infoRPl.petitioner_document;
      this.Bene = this.infoRPl.beneficiary_name;
      this.idBene = this.infoRPl.beneficiary_document; 
      this.subresponsable = this.infoRPl.subresponsible_id; 
      this.descripcion = this.infoRPl.description;

      this.canEdit = 1; // deshabilita todos los campos    
    }
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest",["bps",]),
    ...mapState("modSettle", ["categories","loading"]),
    ...mapState("modRightPetition", [
      "infoRP",
      "responsibles",
      "files",
      "stateProcess",
      "infoRPl",
      "linkProccess",
      "loading",
    ]),    
  },
  methods:{
    ...mapActions("modRightPetition", [
      "actGetInfoRP",
      "actGetResponsibles",
      "actSaveInfoRP",
      "actAddUserForum",
      "actGetfiles",
      "actRecategorize"
    ]),
    ...mapActions("modSettle", [
      "actGetCategories",
    ]),
    ...mapActions("modRequest", [
      "actGetBP",
    ]),
    ...mapMutations("modRightPetition", [
      "setStateProcess",
      "setInfoRPl",
      "setLinkProccess",
      ]),

    pushSubresponsables(){
      this.opcionSubresponsable.push({
      'value': this.infoRP.data.responsible.id,
      'text': this.infoRP.data.responsible.name
      })
      this.infoRP.data.subResponsable.forEach(r => {
         this.opcionSubresponsable.push({
           'value': r.id,
           'text': r.name
         })
      })
    },

    subcategorias(){
      if(this.categoria != this.infoRPl.category_id){
         this.recategorizarValue = true
         return
       }
      this.recategorizarValue = false
      this.opcionSubcategoria = [];
      this.subcategoria = '';
      this.categories.data.forEach(r => {
          if(r.id == this.categoria){
            r.pr_subcategories.forEach(s => {
              this.opcionSubcategoria.push({
                'value': s.id,
                'text': s.name
              });
            });
          }
        });
    },

    subresponsables(){
      this.opcionSubresponsable = [];
      this.subresponsable = '';
      this.infoRP.data.subResponsable.forEach(r => {   
                this.opcionSubresponsable.push({
                  'id': r.core_employees.name,
                  'name': r.core_employees.id,
                  'value': r.core_employees.id,
                  'text': r.core_employees.name
                });
      });

    },

    saveInfoRP(){      
      if(this.fecha != false){
        let data = [];
        data[0] = this.$route.params.id;

        data[1] = {
          'business_partner_id': this.bp,
          'reception_date': this.fecha,
          'petitioner_name': this.nombreSol,
          'petitioner_document': this.idSol,
          'beneficiary_name': this.Bene,
          'beneficiary_document': this.idBene,
          'description': this.descripcion,
          'subresponsible_id': this.subresponsable,
          'subcategory_id': this.subcategoria,
        }

        //alert(JSON.stringify(data));
        this.actSaveInfoRP(data).then(() =>{
            this.actGetInfoRP(this.$route.params.id).then(() =>{
              this.setInfoRPl(this.infoRP.data);
              this.setStateProcess(1);
              this.setLinkProccess(1);
            });
            
          }).catch((response) => {
            this.error.flag = true;
            this.error.class = "is-invalid";
            this.error.message = "Ocurrio un error al actualizar los datos: "+response;
        });
      }
      else{
        this.showModal("Debe seleccionar la fecha de recepción",0);
      }
    },

    recategorizar(){
      this.$bvModal.msgBoxConfirm('Sí recategoriza, podría no volver a ingresar a este derecho de petición. ¿Desea continuar?',
        {
          title: 'Atención al mensaje:',
          size: 'sm',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'CONTINUAR',
          cancelTitle: 'CANCELAR',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if(value == true){
            var formData = new FormData();
            var data = [];

            data[0] = this.$route.params.id;
            formData.append("category_id", this.categoria);
            data[1] = formData;

            this.actRecategorize(data).then(() =>{
              this.$router.push({ path: '/listRP' });
            });
          }
        })
        .catch(err => {
          console.log(err);
        })
    },

    formatDateShow(date){
      var d = new Date(date);
      var datestring = d.getDate()+" "+this.monthNames[d.getMonth()+1] +" "+ d.getFullYear();
      return datestring;
    },

    fileSelected() {
      const dato = document.querySelector('#fileDocu');
      this.nameFile = dato.files[0].name;
      //alert(this.header_img)
    },
    
    showModal(msj,flag) {
        this.msjModal = msj;
        this.flagPath = flag;
        this.$refs['my-modal'].show()
      },
    hideModal() {
        this.$refs['my-modal'].hide()
        if(this.flagPath == 1){
          this.$router.push({ path: '/listRP' });
        }
     },
  }
};
</script>

<style lang="scss">
//@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.page-rightpetition {
  .title-1 {
        font-size: 24px;
        font-weight: bold;
        color: #1C3A4E;
      }
  .cont-rightpetition-text {    
    .cont-title {
      color: #1c3a4e;
      .title-1 {
        font-size: 20px;
        font-weight: bold;
        color: #1c3a4e;
      }
      .title-2 {
        font-weight: bold;
        font-size: 25px;
        line-height: 27px;

        @media (min-width: 768px) {
          font-size: 80px;
          line-height: 80px;
        }
      }
    }
    .form-rightpetition {
      .form-group-req {
        input[type="text"] {
          height: 32px;
          border: 1px solid #454545;
          border-radius: 4px;
          padding: 0 10px;
        }
      }     
           
    }
  }
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }
  .button1 {
    color: #1C3A4E;
    //font-family: "Open Sans";
    //background: #E9ECEE;        
    //border-radius: 50px;
    height: 25px;
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
  }       
  .button2 {
    background: #1C3A4E;
    color: #ffffff;
    border-radius: 50px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#cddce6, 5);
    }
  }
  .button3 {
    border: none;
    background-color: inherit;
    padding: 5px 10px;
    font-size: 11px;
    cursor: pointer;
    display: inline-block;
    text-decoration: underline;
  }
  .button4 {
    background: #99A6AF;
    color: #ffffff;
    border-radius: 8px;
    height: 32px;
    font-size: 16px;
    text-align: left !important;   
    padding-left: 5%;
    padding-right: 5%;
    &:hover {
      background: darken(#99A6AF, 5);
    }
  }
  .button2:hover {background: #eee;}
  .default {color: black;}    
  .tr1{
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #454545;
    padding-left: 5%;
  }   
  .td1 {
    background: #1C3A4E;
    color: #ffffff;
    font-family: "Open Sans";
    font-weight: bold;
    font-size: 12px;
    line-height: 19px;
    padding-left: 1%;
    padding-right: 1%;
    width: 100px;
  }
  .td2 {
    background: #ffffff;
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;
    width: 95px;
    text-align: center;
  }
  .td3 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 25px;
    text-align: center;
  }
  .td4 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 10px;
    line-height: 12px;
    text-align: center;    
  }
  .td5 {
    background: #ffffff;
    color: #303030;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 12px;
  }  
  .tabla1{  
    border-radius: 5px;
    border: 3px solid #1C3A4E;
    border-color: #1C3A4E;  
    -moz-border-radius: 6px;
    border-collapse: separate;
    border-spacing: 0px;
    width: 470px
  }
  .p1 {
    color: #1C3A4E;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 13px;
    line-height: 19px;    
  }
  .collapsed > .when-opened,
      :not(.collapsed) > .when-closed {
          display: none;
      }
  .img1 {
    width: 18px;
    height: 18px;    
    left: 100%;
    top: 100%;     
    float: center;    
  }
  .centerImg1 {
    width: 16px;
    height: 16px;    
    top: 100%;    
    float: right;    
  }
  .mycheck 
  { 
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
  /* The switch - the box around the slider */
  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 4px;
    bottom: 4px;
    background-color: #242424;
    -webkit-transition: .4s;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #779B49;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #779B49;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
  .custom-file-upload {
      border: 1px solid #ccc;
      display: inline-block;
      padding: 1px 2px;
      cursor: pointer;
  }
  input[type="file"] {
    display: none;
  }
  .scrollable {
    overflow: hidden;
    overflow-y: scroll;
    height: calc(30vh - 20px);
  }

  .file-upload-img{
    width:120px;
    height:80px;
    //border-style: dotted;
    text-align: center;
    display: flex;
    align-items: center;
  }
  .file-upload-img img{
      width:100%;
      height:100%;
  }
  input[type="file"]{
      opacity:0;
      filter:alpha(opacity=0);
      display:block;
      width:360px;
      height:200px;
      position:absolute;
      cursor:pointer;
  }

  .switch {
    position: relative;
    display: inline-block;
    width: 45px;
    height: 19px;
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
}
</style>